import React from "react";
import locale from "@bonliva-crm/locale";
import { useObserver } from "mobx-react";
import { Grid, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ThemeType } from "@theme";
import { SocionomStore } from "./SocionomStore";
import { useConsultantEditorContext } from "../../ConsultantEditorContext";
import { ExpKnownSystem, ExpTopPanel, ExpMultiSelect } from "../Common";
import { DoctorAoE } from "@consultants/ConsultantEditor/components/Doctor/DoctorExpertise";
import BasicSelect from "@components/Select";

type Props = {
  profession: string;
  store: SocionomStore;
};

export function SocionomExpertise(props: Props) {
  const editorStore = useConsultantEditorContext();
  const socionomStore = props.store;
  const profItem = `professions.${socionomStore.storeIndex}`;
  const classes = useStyles({});

  return useObserver(() => (
    <>
      <Paper className={classes.paper}>
        <ExpTopPanel
          certifiedPath={`${profItem}.certifiedFrom`}
          certifiedFromTxt={locale.SocionomFrom}
          onDeleteClick={socionomStore.deleteExpertise}
        />

        <ExpMultiSelect
          name={locale.AddVUBDoc}
          selectOptions={socionomStore.selectAoEList}
          onChange={(val) => socionomStore.setSelectedAoE(val)}
          selectedVal={socionomStore.selectedAoE}
          btnClick={() => socionomStore.addAoE()}
          btnDisabled={!socionomStore.selectedAoE}
          error={socionomStore.errorAoe}
        />
      </Paper>

      <DoctorAoE
        areasOfExpertise={socionomStore.areasOfExpertise}
        profItem={profItem}
        profession={socionomStore.profession}
        onDelete={(i) => socionomStore.removeAOEByIndex(i)}
        onToggle={(i) => socionomStore.toggleAOEByIndex(i)}
      />

      <Paper style={{ padding: 16 }}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={6}>
            <ExpKnownSystem
              options={socionomStore.systems}
              onChange={socionomStore.addSystems}
              value={socionomStore.selectedSystems}
              hasValidated={true}
              validate={(e, c) => {
                if (c) {
                  editorStore.consultantCVManager.approveKey(
                    `professions.${socionomStore.storeIndex}.systems`
                  );
                }
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <BasicSelect
              label={locale.Educations}
              fullWidth
              multi
              options={socionomStore.educations.map((x) => ({
                label: x,
                value: x
              }))}
              sortOptions={true}
              optionType={"checkbox"}
              multiType={"chips"}
              onChange={socionomStore.addEducations}
              value={socionomStore.selectedEducations}
            />
          </Grid>
        </Grid>
      </Paper>
    </>
  ));
}

const useStyles = makeStyles((theme: ThemeType) => ({
  paper: {
    ...theme.mixins.childrenMarginBottom(8),
    padding: 16,
    position: "relative"
  }
}));
